/**
 * Load the bugsnag utilities.
 */
require('./bugsnag/bootstrap');

/**
 * Load the confetti utilities.
 */
require('./confetti/bootstrap');

/**
 * Load the form utilities.
 */
require('./forms/bootstrap');

/**
 * Load the helpers utilities
 */
require('./helpers/bootstrap');

/**
 * Load the table utilities.
 */
require('./tables/bootstrap');

/**
 * Load the tooltips utilities.
 */
require('./tooltips/bootstrap');
